/* eslint-disable array-callback-return */
import {useEffect, useState} from "react";
import SegnalazioneDetailFields from "./SegnalazioneDetailFields";

type SegnalazioneDetailSectionInterface = {
    segnalazioneSectionLabelsStructure : any,
    segnalazioneSection : any,
    state : string
}

const SegnalazioneDetailSection = ({segnalazioneSectionLabelsStructure, segnalazioneSection, state} : SegnalazioneDetailSectionInterface) => {

    const [showSubsections, setShowSubsections] = useState<{[key : string] : any}>({})

    useEffect(() => {
        initShowSubsections()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    function initShowSubsections() {
        const tmpShowSubsections : {[key : string] : any}= {}
        Object.keys(segnalazioneSection).map(subsection => {
            tmpShowSubsections[subsection] = true
        })
        setShowSubsections(tmpShowSubsections)
    }

    function toggleShowSubsection(subsection : any) {
        const tmpShowSubsections : {[key : string] : any} = {}
        Object.assign(tmpShowSubsections, showSubsections)
        tmpShowSubsections[subsection] = !showSubsections[subsection]
        setShowSubsections(tmpShowSubsections)
    }

    return (
        <div className="row card-body background-gray">
            {Object.keys(segnalazioneSection).map((subsection) => {
                return <div className="background-white mt-3 card-body" key={subsection}>
                    <div className="row font-medium-custom text-bold">
                        <div className="col-md-8">
                            {segnalazioneSectionLabelsStructure[subsection] ?
                                segnalazioneSectionLabelsStructure[subsection].label
                                :
                                subsection
                            }
                        </div>
                        <div className="d-flex pointer justify-content-end col-md-4 color-primary">
                            <span onClick={() => toggleShowSubsection(subsection)}>
                                {
                                    showSubsections[subsection] ? 'Nascondi campi' : "Mostra campi"
                                }
                            </span>
                        </div>
                    </div>
                    {showSubsections[subsection] ?
                        <SegnalazioneDetailFields
                            segnalazioneFieldsLabels={segnalazioneSectionLabelsStructure[subsection].fields}
                            segnalazioneFields={segnalazioneSection[subsection]}
                            segnalazioneState = {state} />
                            :
                        <></>
                    }
                </div>
            })}
        </div>
    )
}

export default SegnalazioneDetailSection;
